import { brand, ecosystemUnits } from "@/mocks/site";
import { INSTAGRAM_URL, FACEBOOK_URL, TIKTOK_URL, buildWhatsAppLink } from "@/utils/links";

const socials = [
  { icon: "ri-instagram-line", label: "Instagram", href: INSTAGRAM_URL },
  { icon: "ri-facebook-circle-line", label: "Facebook", href: FACEBOOK_URL },
  { icon: "ri-tiktok-line", label: "TikTok", href: TIKTOK_URL },
  { icon: "ri-whatsapp-line", label: "WhatsApp", href: buildWhatsAppLink("Hola ALÉA, quiero información.") },
];

export default function Footer() {
  return (
    <footer className="relative border-t border-secondary-200 bg-background-200">
      <div className="line-gold pointer-events-none absolute inset-x-0 top-0 h-px" />
      <div className="w-full px-5 py-16 md:px-10 md:py-20">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-8">
          <div className="lg:col-span-4">
            <span className="font-heading text-3xl font-extrabold tracking-[0.16em] text-foreground-950">
              AL<span className="text-accent-500">É</span>A
            </span>
            <p className="mt-2 font-label text-[10px] uppercase tracking-[0.22em] text-accent-700">
              Aesthetic House
            </p>
            <p className="mt-6 max-w-xs font-heading text-2xl font-bold leading-snug text-foreground-950">
              {brand.claim}
            </p>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-foreground-600">
              Casa estética integral en {brand.city}: clínica, skincare, formación e insumos para
              profesionales.
            </p>
            <div className="mt-7 flex items-center gap-3">
              {socials.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="nofollow noreferrer"
                  aria-label={social.label}
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-secondary-300 bg-background-50 text-foreground-700 transition-colors duration-300 hover:border-primary-500 hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={`${social.icon} text-lg`} />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-label text-[11px] font-medium uppercase tracking-[0.18em] text-foreground-500">
              <a href="#inicio" className="transition-colors hover:text-foreground-950">
                Unidades ALÉA
              </a>
            </h4>
            <ul className="mt-5 space-y-3">
              {ecosystemUnits.map((unit) => (
                <li key={unit.name}>
                  <a
                    href={unit.href}
                    className="text-sm text-foreground-700 transition-colors duration-300 hover:text-accent-700"
                  >
                    {unit.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-label text-[11px] font-medium uppercase tracking-[0.18em] text-foreground-500">
              <a href="#contacto" className="transition-colors hover:text-foreground-950">
                Contacto
              </a>
            </h4>
            <ul className="mt-5 space-y-3 text-sm text-foreground-700">
              <li className="flex gap-3">
                <i className="ri-map-pin-line mt-0.5 text-base text-accent-700" />
                <span>{brand.address}</span>
              </li>
              <li className="flex gap-3">
                <i className="ri-phone-line mt-0.5 text-base text-accent-700" />
                <span>{brand.phoneDisplay}</span>
              </li>
              <li className="flex gap-3">
                <i className="ri-mail-line mt-0.5 text-base text-accent-700" />
                <span>{brand.email}</span>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-label text-[11px] font-medium uppercase tracking-[0.18em] text-foreground-500">
              <a href="#contacto" className="transition-colors hover:text-foreground-950">
                Horarios
              </a>
            </h4>
            <ul className="mt-5 space-y-3 text-sm text-foreground-700">
              {brand.hours.map((item) => (
                <li key={item.day}>
                  <span className="block text-foreground-900">{item.day}</span>
                  <span className="text-foreground-500">{item.time}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-4 border-t border-secondary-300 pt-7 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs tracking-wide text-foreground-500">
            © {new Date().getFullYear()} {brand.name}. Todos los derechos reservados.
          </p>
          <p className="font-label text-[10px] uppercase tracking-[0.18em] text-foreground-500">
            {brand.city}, {brand.state} · México
          </p>
        </div>
      </div>
    </footer>
  );
}